// extracted by mini-css-extract-plugin
module.exports = {"container":"AccessLevel_container__3aSAf","MT1":"AccessLevel_MT1__x9yRi","MT2":"AccessLevel_MT2__23yRr","RO":"AccessLevel_RO__1wK5l","MANAGER":"AccessLevel_MANAGER__1KAqo"};